export const getSoundId = (name) => {
  const matches = name.replace(/\.([^.]+)$/, '').match(/\d+/g);
  return matches?.length ? Number(matches[matches.length - 1]) : null;
};
